module.exports = __webpack_public_path__ + "img/pic_4.eb375407.png";